import React from 'react';
import styles from './container.module.scss';
import { IconWrapper } from '../../../Atoms/icons/Icon';
import Buttons from '../../../Atoms/Buttons/Buttons';
import { useFormikContext } from 'formik';
import LoaderButton from '../../Loader/LoaderButton';
const Footer = ({ isPending }) => {
  const { handleSubmit } = useFormikContext();

  return (
    <div className={styles.footer}>
      {/* <IconWrapper icon='delete' color='red' /> */}
      <div></div>
      <div>
        {isPending ? (
          <div className={styles.loaderCont}>
            <div className={styles['loader']}></div>
          </div>
        ) : (
          <>
            {/* <Buttons rounded color='#b0b0b0ff' text='Save Draft' /> */}
            <Buttons
              rounded
              color='red'
              text='Send Email'
              handleOnClick={handleSubmit}
              disabled={isPending}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Footer;
